"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass.js");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function __export(target, all) {
  for (var name in all) {
    __defProp(target, name, {
      get: all[name],
      enumerable: true
    });
  }
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && typeof from === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step;
    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return to;
};
var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};
var localStorageBroadcastChannel_exports = {};
__export(localStorageBroadcastChannel_exports, {
  LocalStorageBroadcastChannel: function LocalStorageBroadcastChannel() {
    return _LocalStorageBroadcastChannel;
  }
});
module.exports = __toCommonJS(localStorageBroadcastChannel_exports);
var KEY_PREFIX = "__lsbc__";
var _LocalStorageBroadcastChannel = /*#__PURE__*/function () {
  function _LocalStorageBroadcastChannel(name) {
    var _this = this;
    _classCallCheck(this, _LocalStorageBroadcastChannel);
    this.eventTarget = window;
    this.postMessage = function (data) {
      try {
        localStorage.setItem(_this.channelKey, JSON.stringify(data));
        localStorage.removeItem(_this.channelKey);
      } catch (e) {}
    };
    this.addEventListener = function (eventName, listener) {
      _this.eventTarget.addEventListener(_this.prefixEventName(eventName), function (e) {
        listener(e);
      });
    };
    this.setupLocalStorageListener = function () {
      var notifyListeners = function notifyListeners(e) {
        if (e.key !== _this.channelKey || !e.newValue) {
          return;
        }
        try {
          var data = JSON.parse(e.newValue || "");
          var event = new MessageEvent(_this.prefixEventName("message"), {
            data: data
          });
          _this.eventTarget.dispatchEvent(event);
        } catch (e2) {}
      };
      window.addEventListener("storage", notifyListeners);
    };
    this.channelKey = KEY_PREFIX + name;
    this.setupLocalStorageListener();
  }
  _createClass(_LocalStorageBroadcastChannel, [{
    key: "prefixEventName",
    value: function prefixEventName(eventName) {
      return this.channelKey + eventName;
    }
  }]);
  return _LocalStorageBroadcastChannel;
}(); // Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  LocalStorageBroadcastChannel: _LocalStorageBroadcastChannel
});